import { getIsoCode } from '~/i18n/helpers'
import { type LocaleCode } from '~/i18n/config'
import { LanguageId } from '~/api/graphql/generated'
import type { Language } from '~/types/shopware'

// Re-export for backward compatibility
export type LanguageCode = LocaleCode

export const useLocale = () => {
  const { availableLocales, locale } = useI18n()
  const router = useRouter()
  const { getAvailableLanguages } = useInternationalization()

  const languageCode = computed(() => locale.value as LanguageCode)
  const languageCODE = computed(() => locale.value.toUpperCase() as LanguageId)

  const getLanguageId = async () => {
    const { data } = await useAsyncData('languages', async () => {
      return await getAvailableLanguages()
    })

    if (data.value?.elements.length && router.currentRoute.value.name) {
      const isoCode = getIsoCode(availableLocales, router.currentRoute.value.name as string)
      return data.value?.elements.find((language: Language) => language?.translationCode?.code === isoCode)?.id
    }

    return undefined
  }

  return {
    languageCode,
    languageCODE,
    getLanguageId,
  }
}
